import React from 'react';
import { Link } from 'react-router-dom';
import './NotFound.css';

const NotFound = () => {
    return (
        <div className="notfound-container">
            <h1 className="notfound-title">404</h1>
            <h2>Page Not Found</h2>
            <p>The page you are looking for doesn't exist or has been moved.</p>
            <Link to="/" className="notfound-link">
                Return to Home
            </Link>
        <footer>
            <Link to="/legal-mention">Mentions légales</Link>
        </footer>
        </div>
    );
};

export default NotFound